import { js_utils } from "./frfr-js-utils";


// const frfr_lib_changes_id = '/FRFR/frfr-tags-utils.js/changes_id2026-04-24r1/';


/* 
FrFr FRIENDLY FRAMEWORK
frfr-tags-utils.js
Version ID: (look at frfr_lib_changes_id)
by 
// Please describe here if you customized this file
*/

/*

*/


export const tags_utils = {};


//
tags_utils.TAGS_CSV_SEPARATOR = ','; // COMMA SEPARATOR FOR CSV TAGS


//
tags_utils.fix_tag_lowercase = (tag) => {
  let fixed_tag = '';
  if (typeof tag === 'string') {
    fixed_tag = tag.trim().toLowerCase();
  }
  return fixed_tag;
};


//
tags_utils.convert_tags_csv_to_tags_arr = (tags_csv) => {
  const tags_arr = js_utils.string_split_to_arr_but_exclude_empty(tags_csv, tags_utils.TAGS_CSV_SEPARATOR);
  return tags_arr;
};


//
tags_utils.convert_tags_arr_to_tags_csv = (tags_arr) => {
  let tags_csv = '';
  if (Array.isArray(tags_arr)) {
    tags_csv = tags_arr.join(tags_utils.TAGS_CSV_SEPARATOR);
  }
  return tags_csv;
};


//
tags_utils.is_tag_exist_in_tags_arr = (tags_arr, tag, flag_case_sensitive) => {
  if (typeof tag === 'string' && Array.isArray(tags_arr)) {
    if (flag_case_sensitive === true) {
      if (tags_arr.some(item => item === tag)) {
        // BINGO match CASE SENSITIVE
        return true;
      }
    } else {
      if (tags_arr.some(item => item.toLowerCase() === tag.toLowerCase())) {
        // BINGO match CASE INSENSITIVE
        return true;
      }
    }
  }
  return false;
};


//
tags_utils.is_tag_exist_in_tags_csv = (tags_csv, tag, flag_case_sensitive) => {
  if (typeof tag === 'string' && typeof tags_csv === 'string') {
    const tags_arr = tags_utils.convert_tags_csv_to_tags_arr(tags_csv);
    // if (tags_arr.includes(_new_tag)) {
    return tags_utils.is_tag_exist_in_tags_arr(tags_arr, tag, flag_case_sensitive)
  }
  return false;
};

